import { createConfirmation } from "react-confirm";
import AddCategoryDialog from "./AddCategoryDialog";

export const showAddCategoryDialog = createConfirmation(AddCategoryDialog);
